export const SHARE_URL = "https://quizrun.org";
const SHARE_TEXT = "Quizrun — a 5K race where quiz answers cut your time 🏃🧠";

export const canNativeShare = () =>
  typeof navigator !== "undefined" && "share" in navigator;

export const nativeShare = () =>
  navigator.share({ title: "Quizrun", text: SHARE_TEXT, url: SHARE_URL }).catch(() => {
    /* user cancelled share dialog */
  });

export const telegramShareUrl = () =>
  `https://t.me/share/url?url=${encodeURIComponent(SHARE_URL)}&text=${encodeURIComponent(SHARE_TEXT)}`;
